export const createApplicationAccount = `
    mutation createAccountApplication($input: CreateAccountApplicationInput!) {
        createAccountApplication(input:$input) {
          id
          accountId
          applicationId
          application {
              id
              name
          }
          accountApplicationStatus
    }
}`;

export const updateApplicationAccount = `
    mutation updateAccountApplication($input: UpdateAccountApplicationInput!) {
        updateAccountApplication(input:$input){
              id
              accountId
              applicationId
              application {
                  id
                  name
              }
              accountApplicationStatus
        }
}`;

export const deleteApplicationAccount = `
    mutation deleteAccountApplication($input: DeleteAccountApplicationInput!) {
        deleteAccountApplication(input:$input) {
            id
        }
}`;
